<div class="component-card">
    <div style="display: inline-block;width: 100%;">
        <h1 class="component-title">{{'Payment Processors'|translate}}</h1>
        <i class="pi pi-ellipsis-v spam-menu"></i>
    </div>
    <div class="panel_wrapper">
        <div class="d-flex flex-row justify-content-between pb-4">
            <div class="p-inputgroup div_search_field w-75">
                <button type="button" class="search_btn_icon"><i class="pi pi-search"></i></button>
                <input type="text" class="input_text_search_field" placeholder="Search...">
                <button type="button" class="search_btn_icon"><i class="pi pi-times"></i></button>
            </div>
            <p-dropdown class="src_dropdown" [options]="src_drop_opt" [(ngModel)]="selected_drop_opt" optionLabel="name"
                optionValue="id"></p-dropdown>
            <div class="p-inputgroup div_search_field ps-3 w-50">
                <input type="text" class="input_text_search_field" placeholder="Location...">
                <button type="button" class="search_btn_icon"><i class="pi pi-times"></i></button>
            </div>
            <button class="btn_in_color w-25" (click)="addNewPaymentProcessors()">{{ 'Add New' | translate}} +</button>
        </div>
    </div>
</div>

<div class="div_grid" style="padding-right: 4px; height: 500px;overflow-y: auto;overflow-x: hidden;" infiniteScroll
    [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000" (scrolled)="loadMorePaymentProcessors()"
    [scrollWindow]="false">
    <div *ngFor="let item of paymentProcessorList" style="height: 460px;" class="vertical_component_card">
        <div class="component-list-card h-100 d-flex flex-column align-items-center pt-4">
            <img class="payment_proc_image" [src]="!item.ImagePath ? imagePath :item.ImagePath " alt="profile-picture">

            <div class="text-center mt-3 mb-2 ">
                <label class="lbl_proc_name">{{item.Name}}</label>
                <label class="lbl_proc_web">{{item.WebSite}}</label>

                <div class="mt-4 div_cont_proc">
                    <div class="mb-3">
                        <label class="lbl_proc text-start w-100">{{ 'MEMBERS' | translate }}</label>
                        <label class="lbl_proc_content">{{item.Members}}</label>
                    </div>
                    <div class="mb-3">
                        <label class="lbl_proc text-start w-100">{{ 'PAYMENTS' | translate }}</label>
                        <label class="lbl_proc_content">{{item.Payments}}</label>
                    </div>
                </div>
                <div class="div_cont_proc">
                    <div class="mb-3">
                        <label class="lbl_proc text-start w-100">{{ 'COUNTRIES' | translate }}</label>
                        <label class="lbl_proc_content">{{item.Countries}}</label>
                    </div>
                    <div class="mb-3">
                        <label class="lbl_proc text-start w-100">{{ 'CURRENCIES' | translate }}</label>
                        <label class="lbl_proc_content">{{item.Currencies}}</label>
                    </div>
                </div>
                <label class="lbl_proc text-start w-100">{{ 'FUNDS PROCESSED' | translate }}</label>
                <label class="lbl_proc_content">{{item.FundsProcessed}}</label>
            </div>

            <div class="mt-auto">
                <button class="btn_in_color w-100  mb-2" (click)="detailsProcessorList(item.Id )">{{ 'Details' |
                    translate}}</button>
                <button class="btn_without_color btn_border_color me-2" (click)="suspendProcessorList(item.Id )">{{
                    'Suspend' |
                    translate}}</button>
                <button class="btn_without_color btn_border_color " (click)="deleteProcessorList(item.Id)">{{ 'Delete'
                    | translate}}</button>
            </div>
        </div>
    </div>
</div>